import produce from 'immer';

import * as actions from './actions';

export default produce((state, action) => {
  switch (action.type) {
  case actions.SET_SHADOWS:
    state.loaded = true;
    state.sorted = action.shadows.sort((a, b) => a.updatedAt < b.updatedAt ? 1 : -1);
    break;

  case actions.MARK_SHADOWS_DIRTY:
    state.loaded = false;
    break;

  case actions.CREATING_SHADOW:
    state.creatingShadow = true;
    break;

  case actions.DONE_CREATING_SHADOW:
    state.creatingShadow = false;
    break;

  case actions.ADD_SHADOW:
    state.sorted.unshift(action.shadow);
    break;

  case actions.UPDATE_SHADOW: {
    const shadowIndex = state.sorted.findIndex((shadow => shadow.id == action.shadow.id));
    state.sorted[shadowIndex] = action.shadow;
    break;
  }

  case actions.REMOVE_SHADOW:
    state.sorted = state.sorted.filter(shadow => shadow.id !== action.shadow.id);
    break;

  case actions.SELECT_SHADOW:
    state.selected = action.shadow;
    break;
  }
}, {});
